import { render, staticRenderFns } from "./screen_facturaciongeneral.vue?vue&type=template&id=5daa1d90&scoped=true"
import script from "./screen_facturaciongeneral.vue?vue&type=script&lang=js"
export * from "./screen_facturaciongeneral.vue?vue&type=script&lang=js"
import style0 from "./screen_facturaciongeneral.vue?vue&type=style&index=0&id=5daa1d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa1d90",
  null
  
)

export default component.exports